import React from 'react'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import { toastr } from 'react-redux-toastr'
import { CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { selectEncoders, selectEncodersFetching } from '../../../../../selectors/omnitecSelectors/omnitecEncoders'
import { connect } from 'react-redux'
import { fetchOmnitecEncoders, createOmnitecEncoders, deleteOmnitecEncoders } from '../../../../../api/omnitecApi/omnitecEncoders'
import { selectCurrentOrganization } from '../../../../../selectors/omnitecSelectors/omnitecOrganizations'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class EncodersTab extends React.Component {
    state = {
        name: ''
    }

    componentDidMount() {
        this.props.fetchOmnitecEncoders(this.props.currentOrganization)
    }

    componentDidUpdate(prevProps) {
        const { currentOrganization } = this.props
        if (prevProps.currentOrganization && prevProps.currentOrganization !== currentOrganization) {
            this.props.fetchOmnitecEncoders(this.props.currentOrganization)
        }
    }

    handleClick = () => {
        const { name } = this.state
        const { currentOrganization, createOmnitecEncoders } = this.props
        const toSave = {
            name,
            organizationId: currentOrganization
        }
        createOmnitecEncoders(toSave)
        this.setState({ name: '' })
    }

    handleChange = e => {
        this.setState({ name: e.target.value })
    }

    handleDelete = id => {
        const toastrConfirmOptions = {
            onOk: () => this.props.deleteOmnitecEncoders(id)
        }
        toastr.confirm('Вы уверены, что хотите удалить энкодер?', toastrConfirmOptions)
    }

    render() {
        const { classes, currentOrganization, omnitecEncoders, isFetching } = this.props

        const valid = !!this.state.name

        return (
            <div>
                <div className={classes.root}>
                    <Paper className={classes.paper}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="categories-remote-name">Название энкодера</InputLabel>
                            <Input
                                id="categories-remote-name"
                                name="name"
                                value={this.state.name}
                                onChange={this.handleChange}
                            />
                        </FormControl>

                        <Button
                            disabled={!valid}
                            variant="raised"
                            color="primary"
                            className={classes.button}
                            onClick={this.handleClick}
                        >
                            Сохранить
                        </Button>
                    </Paper>
                </div>
                <div style={{ marginTop: '20px' }}>
                    <Paper className={classes.paper}>
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    <TableCell>name</TableCell>
                                    <TableCell>Client ID</TableCell>
                                    <TableCell>Действие</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {omnitecEncoders.map(item => (
                                    <TableRow hover key={item.id}>
                                        <TableCell>{item.id}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.clientId}</TableCell>
                                        <TableCell>
                                            <IconButton aria-label="Delete" onClick={() => this.handleDelete(item.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Paper>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isFetching: selectEncodersFetching(state),
    omnitecEncoders: selectEncoders(state),
    currentOrganization: selectCurrentOrganization(state)
})

export default connect(
    mapStateToProps,
    { fetchOmnitecEncoders, createOmnitecEncoders, deleteOmnitecEncoders }
)(withStyles(styles)(EncodersTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/EncodersTab/EncodersTab.js